import orderBy from "lodash/orderBy";

import fetchCategoryPosts from "common/fetch/fetchCategoryPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout/index";
import HongKongTradingGuide from "components/templates/hk/guide-and-tool/hong-kong-trading-guide";

import dataJson from "./data.json";

export default function HKTradingGuide({ data }) {
  return (
    <Layout locationRouter="hk" page={data.page}>
      <HongKongTradingGuide data={dataJson} posts={data.posts} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const locale = "hk";
  const uri = "/guide-and-tool/hong-kong-trading-guide";

  const page = await fetchSeo({
    uri,
    locale,
  });

  const posts = await fetchCategoryPosts({
    name: "/trading",
    locale,
    size: "LARGE",
    variables: [
      {
        name: "where",
        type: "CategoryToPostConnectionWhereArgs",
        value: {
          in: [14084, 14397, 14460, 14486, 14509, 14588, 14608, 14616],
        },
      },
    ],
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: orderBy(posts, ["date"], ["asc"]) || {},
      },
    },
  };
};
